import { SixPageWrapper } from '../../components/SixPageWrapper/SixPageWrapper';
import { MenuItems } from '../../types/MenuItems';
import { SixSectionWrapper } from '../../components/SixSectionWrapper/SixSectionWrapper';
import { getTranslation } from '../../constants/translations';

import image1 from '../../assets/images/shop/shop_page_1.webp';
import image2 from '../../assets/images/shop/shop_page_2.png';
import image3 from '../../assets/images/shop/shop_page_3.webp';
import image4 from '../../assets/images/shop/shop_page_4.webp';
import image5 from '../../assets/images/shop/shop_page_5.webp';

import './Shop.scss';

const images = [image1, image2, image3, image4, image5];

export const Shop = () => {
  const style = window.getComputedStyle(document.body as HTMLElement);
  const t = getTranslation();

  return (
    <>
      <SixPageWrapper
        section={MenuItems.SHOP}
        title={t.SHOP.title}
        itemsList={t.SHOP.subsections.map((ss, i) => ({
          ...ss,
          link: `#${MenuItems.SHOP}-page-${i + 1}`,
        }))}
      />

      {t.SHOP.subsections.map((subsection, i) => (
        <SixSectionWrapper
          key={i}
          id={`${MenuItems.SHOP}-page-${i + 1}`}
          color={style.getPropertyValue('--green')}
          imgURL={images[i]}
          title={subsection.title}
          textContent={subsection.content}
        />
      ))}
    </>
  );
};
